import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import Td from "@visa/vds/td";
import Tr from "@visa/vds/tr";
import Icon from "@visa/vds/icon";
import MCSPagedTable from "../../../components/MCSPagedTable";
import { PageHelper } from "../../../_helpers/PageHelper";
import { DafHelper } from "../../../_helpers/DafHelper";
import DafGmrStatusLink from "./DafGmrStatusLink";

// DafTabOneRequestTable is used to display table for TabOneRequest and TabTwoRequest
const DafTabOneRequestTable = (props) => {
  const dafUpload = props.dafUpload;
  const dafUploadId = dafUpload.id;
  const alertObj = props.alertObj;
  const fetchData = props.fetchData;
  const [selectedPage, setSelectedPage] = useState(1);
  const [sortBy, setSortBy] = useState("RecordNo");
  const [desc, setDesc] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [totalPage, setTotalPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 10;

  let colHeaders = [
    {
      displayName: "Record#",
      name: "RecordNo",
      orderable: true,
    },
    {
      displayName: "Acquirer BID",
      name: "AcquirerBID",
      orderable: true,
    },
    {
      displayName: "VMID",
      name: "vmid",
      orderable: true,
    },
    {
      displayName: "VMID Merchant Name",
      name: "vmidMerchantName",
      orderable: true,
    },
    {
      displayName: "EU Region Participation",
      name: "EUParticipation",
      orderable: true,
    },
    {
      displayName: "GMR Status",
      name: "GMRStatus",
      orderable: true,
    },
    {
      displayName: "VSS VMID Processing Result",
      name: "ProcessResult",
      orderable: true,
    },
    { displayName: "Other Info", name: "OtherInfo", orderable: false },
  ];

  const handleClickAction = (tabOneRequest) => {
    props.handleClickAction(tabOneRequest);
  };

  const fetch = async (page, sortBy, desc) => {
    let skipCount = PageHelper.GetSkipCount(pageSize, page);
    trackPromise(
      fetchData(dafUploadId, skipCount, sortBy, desc, pageSize)
        .then((result) => {
          var response = result.data;
          setTableData(response.items);
          setTotalCount(response.totalCount);
          setTotalPage(
            PageHelper.GetTotalCountToPages(pageSize, response.totalCount)
          );
        })
        .catch((error) => {
          if (alertObj) alertObj.setErrorMessage(error.message);
        })
    );
  };

  const handleSortChange = async (sortBy = null, desc = false) => {
    fetch(selectedPage, sortBy, desc);
  };

  const handlePageChange = (newPage) => {
    setSelectedPage(newPage);
    fetch(newPage, sortBy, desc);
  };

  useEffect(() => {
    fetch(selectedPage, sortBy, desc);
  }, []);

  return (
    <>
      <MCSPagedTable
        size={"compact"}
        colHeaders={colHeaders}
        usePagination={true}
        selectedPage={selectedPage}
        setSelectedPage={handlePageChange}
        totalPages={totalPage}
        pageSize={pageSize}
        totalCount={totalCount}
        ordered={sortBy}
        setOrdered={setSortBy}
        sortData={handleSortChange}
        isDsc={desc}
        setDsc={setDesc}
        tableData={
          tableData &&
          tableData.map((row, key) => (
            <Tr key={key}>
              <Td>{row.recordNo}</Td>
              <Td>{row.acquirerBid}</Td>
              <Td>{row.vmid}</Td>
              <Td>{row.vmidMerchantName}</Td>
              <Td>
                {DafHelper.DisplayEURegionParticipation(row.euParticipation)}
              </Td>
              <Td>
                {row.gmrStatus}
                {row.gmrStatus && !DafHelper.IsGMRStatusOK(row.gmrStatus) && (
                  <DafGmrStatusLink />
                )}
              </Td>
              <Td>{row.processResultName}</Td>
              <Td>
                <Icon
                  className="vss-clickable-icon"
                  name="info"
                  resolution="low"
                  onClick={() => handleClickAction(row)}
                />
              </Td>
            </Tr>
          ))
        }
      />
    </>
  );
};
export default DafTabOneRequestTable;
